import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Drawer, Link, Loading } from 'tdesign-react';
import Descriptions from '@/components/Descriptions';
import { fetchHostDetail } from '@/slices/resourceSlice';
import { isVoid } from '@/utils/common';

function Detail({ detail = {}, loading, fetchHostDetail, info }) {
  const [visible, setVisible] = useState(false);
  const { id } = detail;
  useEffect(() => {
    if (!isVoid(id) && visible) {
      fetchHostDetail(id);
    }
  }, [id, fetchHostDetail, visible]);

  const cpuInfo = JSON.parse(info.cpuInfo || '{}');
  const memoryInfo = JSON.parse(info.memoryInfo || '{}');
  const diskInfo = JSON.parse(info.diskInfo || '{}');

  return (
    <>
      <Link theme='primary' hover='color' onClick={() => setVisible(true)}>
        {detail.hostName}
      </Link>
      <Drawer
        header={detail.hostName}
        size={550}
        footer={null}
        visible={visible}
        onClose={() => setVisible(false)}
      >
        <Loading loading={loading}>
          <Descriptions title='基本信息' column={1} emptySuffix='-'>
            <Descriptions.Item label='主机名称' value={info.hostName} />
            <Descriptions.Item
              label='连接地址'
              value={`${info.hostUser || '-'}@${info.hostIp || '-'}`}
            />
            <Descriptions.Item label='连接端口' value={info.hostPort} />
            <Descriptions.Item label='描述信息' value={info.desc} />
          </Descriptions>
          <Descriptions column={1} emptySuffix='-' title='扩展信息' style={{ marginTop: 10 }}>
            <Descriptions.Item label='操作系统' value={cpuInfo.modelName} />
            <Descriptions.Item label='CPU' value={`${cpuInfo.processorNumber || '-'}核`} />
            <Descriptions.Item label='内存' value={`${memoryInfo.memorySize || '-'}GB`} />
            <Descriptions.Item label='磁盘' value={diskInfo.diskSize} />
            <Descriptions.Item label='内网IP' value={info.privateIpAddress} />
            <Descriptions.Item label='公网IP' value={info.publicIpAddress} />
            <Descriptions.Item label='创建时间' value={info.createTime} type='datetime' />
            <Descriptions.Item label='更新时间' value={info.modifyTime} type='datetime' />
          </Descriptions>
        </Loading>
      </Drawer>
    </>
  );
}

export default connect(
  (state) => ({
    loading: state.resource.hostDetailFetching,
    info: state.resource.hostDetail,
  }),
  {
    fetchHostDetail,
  },
)(Detail);
